import * as path from "path";

import { ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";
import { BuildCache, FormBuildCacheOptions } from "../../FormWebpackConfiguration/CacheAssetsPlugin";

import { writeResourceFile } from "./WriteResourceFile";

export async function writeExtendedSchemaFiles(
    gfv: string,
    formDirectory: string,
    resourcesDirectory: string,
    parentLogger: ILogger = getLogger(),
    buildCache?: BuildCache,
    buildCacheOptions?: FormBuildCacheOptions,
    buildCacheExist?: boolean
): Promise<void> {
    return writeResourceFile(
        "FLASHNORM",
        "extendedSchema.json",
        path.join("schemas", `${gfv}.extendedSchema.json`),
        gfv,
        formDirectory,
        resourcesDirectory,
        parentLogger,
        buildCache,
        buildCacheOptions,
        buildCacheExist
    );
}
